<template>
  <div class="modal fade" id="permissionAccessModal">
    <div class="modal-dialog success-modal-wrapper">
      <div class="modal-content expiry-modal-content">
        <div class="modal-header">
          <div class="card text-center">
            <div class="row">
              <div class="col-lg-12 card-text">
                <p class="success-message">Permission Status</p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 card-text">
              <h5 class="success-message">
                 You currently do not have permissions to access this section, please contact your Admin.
              </h5>
              </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 ok-btn">
                <button
                  class="btn btn-block emergo-blue-button" data-dismiss="modal"
                >OK</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
};
</script>

<style scoped>
.modal .modal-dialog .modal-content {
  border-radius: 10px;
}
.modal .modal-dialog .modal-content .modal-header {
  background: #f2f2f2;
  border-radius: 10px;
}
.card .card-body .card-title p.first-card-title {
  font-size: 25px;
  padding-top: 30px;
  color: #4c9e45;
  font-weight: 500;
}

.card .card-body .card-text p.first-card-text {
  padding-top: 30px;
  font-size: 18px;
  font-weight: 300;
  margin-bottom: 0px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 19px;
}

img.success_logo.card-img-top {
    width: 50px;
    height: 50px;
    background-color: #94d66b;
    border-radius: 50%;
    padding: 10px;
}
.error-message, .success-message {
  padding-top: 10px;
  padding-bottom: 20px;
  color: rgba(0, 0, 0, 0.7);
  line-height: 22px;
  font-size: 16px;
  font-weight: 300;
}
.success-message {
  padding: 0px 20px;
  margin-bottom: 24px;
  padding-bottom: 0px;
}
.ok-btn {
  width: 50%;
  margin: auto;
  float: initial;
}
@media screen and (min-width: 768px) {
  .success-modal-wrapper{
    width: 500px;
  }
}
</style>
